import { ArrowRightOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Divider, Flex } from "antd";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux-hooks";
import { setAITemplateModalState, setCustomTemplateSelectedTab, setSelectedView } from "../../../slices/appStateSlice";
import styles from "./AITemplateModal.module.scss";
import List from "./List";
import TemplateListContainer from "./TemplateListContainer.component";
import { type CustomNote, TabType, ViewType } from "./types";

const ListContainer = ({
  handleEditTemplate,
  customNoteList,
  fetchCustomNoteList,
  isListLoading,
}: {
  setIsPrimaryButtonDisabled?: (disabled: boolean) => void;
  handleEditTemplate: (template: CustomNote) => void;
  isListLoading: boolean;
  customNoteList: CustomNote[];
  fetchCustomNoteList: () => void;
}) => {
  const componentName = "ai-template-modal";
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const navigateToTemplateGallery = () => {
    dispatch(setAITemplateModalState(false));
    dispatch(setSelectedView(ViewType.TEMPLATE));
    navigate("/templates");
  };

  function Header() {
    return (
      <>
        <div className={styles[`${componentName}__header`]}>
          <div className={styles[`${componentName}__header-container`]}>
            <button
              onClick={() => dispatch(setAITemplateModalState(false))}
              className={styles[`${componentName}__header-close-button`]}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                width={20}
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
              </svg>
            </button>

            <h3>My Templates</h3>
          </div>
          <Button
            type="primary"
            onClick={() => dispatch(setCustomTemplateSelectedTab(TabType.CREATE))}
            icon={<PlusOutlined />}
            aria-label="Create Template"
            title="Create Template"
          >
            Create Template
          </Button>
        </div>
        <Divider style={{ marginBlock: "0" }} />
      </>
    );
  }

  const userOwnedCustomNotes = customNoteList.filter((note) => note.is_owner);

  return (
    <>
      <Header />
      <div className={styles[`${componentName}__list-header`]}>My Templates</div>
      <List
        handleEditTemplate={handleEditTemplate}
        customNoteList={userOwnedCustomNotes}
        fetchCustomNoteList={fetchCustomNoteList}
        isListLoading={isListLoading}
      />
      <Flex className={styles[`${componentName}__list-header-cont`]} style={{ marginTop: "20px" }}>
        <div className={styles[`${componentName}__list-header`]}>TEMPLATE GALLERY</div>
        <Button onClick={navigateToTemplateGallery} className={styles[`${componentName}__list-header-button`]}>
          20+ templates | View all templates <ArrowRightOutlined />
        </Button>
      </Flex>
      <TemplateListContainer />
    </>
  );
};

export default ListContainer;
